
export function goToMpt(path) {
    window.open(path, '_self')
  }